import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const radioIndicatorDefaultVariants = {
  "size": "md"
}
const radioIndicatorCompoundVariants = []

const radioIndicatorSlotNames = [
  [
    "indicatorArea",
    "radioIndicator__indicatorArea"
  ],
  [
    "icon",
    "radioIndicator__icon"
  ]
]
const radioIndicatorSlotFns = /* @__PURE__ */ radioIndicatorSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, radioIndicatorDefaultVariants, getSlotCompoundVariant(radioIndicatorCompoundVariants, slotName))])

const radioIndicatorFn = memo((props = {}) => {
  return Object.fromEntries(radioIndicatorSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const radioIndicatorVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...radioIndicatorDefaultVariants, ...compact(variants) })

export const radioIndicator = /* @__PURE__ */ Object.assign(radioIndicatorFn, {
  __recipe__: false,
  __name__: 'radioIndicator',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: radioIndicatorVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, radioIndicatorVariantKeys)
  },
  getVariantProps
})